import type { TouchJoystickVisual } from '../core/input';

const BASE_SIZE = 76;
const KNOB_SIZE = 28;
const KNOB_RADIUS = KNOB_SIZE / 2;
const KNOB_RANGE = 23;

export class TouchJoystick implements TouchJoystickVisual {
  private readonly root: HTMLDivElement;
  private readonly knobWrap: HTMLDivElement;

  constructor(mount: HTMLElement) {
    this.root = document.createElement('div');
    this.root.className = 'touch-joystick';
    Object.assign(this.root.style, {
      position: 'absolute',
      right: 'calc(18px + env(safe-area-inset-right, 0px))',
      bottom: 'calc(34px + env(safe-area-inset-bottom, 0px))',
      width: `${BASE_SIZE}px`,
      height: `${BASE_SIZE}px`,
      opacity: '0',
      pointerEvents: 'none',
      userSelect: 'none',
      zIndex: '45',
      transform: 'translate3d(0, 0, 0)',
      transition: 'opacity 120ms cubic-bezier(0.16, 1, 0.3, 1)',
      willChange: 'transform, opacity',
    });

    const base = document.createElement('div');
    Object.assign(base.style, {
      position: 'absolute',
      inset: '0',
      borderRadius: '50%',
      border: '2px solid rgba(255, 210, 74, 0.34)',
      background:
        'radial-gradient(circle, rgba(255,210,74,0.10) 0 29%, rgba(167,139,250,0.08) 30% 63%, rgba(232,228,240,0.18) 64%, rgba(14,11,22,0.06) 68%)',
      boxShadow: 'inset 0 0 0 1px rgba(232,228,240,0.12), 0 5px 12px rgba(5,4,10,0.38)',
    });

    this.knobWrap = document.createElement('div');
    Object.assign(this.knobWrap.style, {
      position: 'absolute',
      left: '50%',
      top: '50%',
      width: '0',
      height: '0',
      transform: 'translate3d(0, 0, 0)',
      willChange: 'transform',
    });

    const knob = document.createElement('div');
    Object.assign(knob.style, {
      position: 'absolute',
      left: `${-KNOB_RADIUS}px`,
      top: `${-KNOB_RADIUS}px`,
      width: `${KNOB_SIZE}px`,
      height: `${KNOB_SIZE}px`,
      borderRadius: '50%',
      border: '2px solid rgba(255, 241, 190, 0.62)',
      background: 'linear-gradient(180deg, rgba(255,210,74,0.74), rgba(240,168,30,0.54))',
      boxShadow: 'inset 0 2px 0 rgba(255,255,255,0.18), 0 3px 8px rgba(5,4,10,0.45)',
    });

    this.knobWrap.appendChild(knob);
    this.root.append(base, this.knobWrap);
    mount.appendChild(this.root);
  }

  start(_x: number, _y: number): void {
    this.root.style.opacity = '0';
    this.knobWrap.style.transform = 'translate3d(0, 0, 0)';
  }

  move(dx: number, dy: number, maxRadius: number): void {
    const distance = Math.hypot(dx, dy);
    this.root.style.opacity = distance > 4 ? '0.9' : '0';
    const scale = maxRadius > 0 ? KNOB_RANGE / maxRadius : 0;
    this.knobWrap.style.transform = `translate3d(${Math.round(dx * scale)}px, ${Math.round(dy * scale)}px, 0)`;
  }

  end(): void {
    this.root.style.opacity = '0';
    this.knobWrap.style.transform = 'translate3d(0, 0, 0)';
  }
}
